// extracted by mini-css-extract-plugin
export default {"addButton":"PresentationConfigsByStage__addButton-aYWX3","targetsField":"PresentationConfigsByStage__targetsField-SIufJ"};